module.exports = __webpack_public_path__ + "img/heart-fill-o.834f4515.svg";